import React from 'react'
import { Typography, Form, Input, Switch, Select, Button, Row, Col } from 'antd'
import IShelter from '../../../../interfaces/IShelter'
import ILanguage from '../../../../interfaces/ILanguage'
import { SearchRequest } from '../../../../services/api/interfaces/ApiRequest'

type ShelterSponsorMeProps = {
  form: any

  shelter: IShelter | null,
  languages: ILanguage[] | null,

  contentLoading: boolean,

  loadLanguages: (args: SearchRequest) => void
}

export default class ShelterSponsorMe extends React.Component<ShelterSponsorMeProps> {

  static defaultProps = {
    contentLoading: false
  }

  state = {
    selectedLanguages: [...[this.props.shelter?.country?.default_language?.uuid || []]] as string[]
  }

  private TRANSLATION_FORM_PATH = ['shelter_setting', 'sponsor', 'translation'] as const

  componentDidMount() {
    const { languages, contentLoading, loadLanguages } = this.props

    if (!languages && !contentLoading && loadLanguages) {
      loadLanguages({
        options: {
          limit:9999
        }
      })
    }
  }

  handleSelectLanguageChange = (name: any[], value: string) => {
    const { form } = this.props

    form.setFields([
      {
        name: [...this.TRANSLATION_FORM_PATH, ...name],
        value: value
      }
    ])

    this.setState((state: any) => ({
      ...state,
      selectedLanguages: [
        ...state.selectedLanguages,
        value
      ]
    }))
  }

  selectLanguage = (fieldName: number) => {
    const { form, contentLoading } = this.props
    const { selectedLanguages } = this.state
    let languages = this.props.languages || []

    // Field path name
    const name: any[] = [fieldName, 'language']

    // Get current value from this select
    const value = form.getFieldValue([...this.TRANSLATION_FORM_PATH, ...name])

    languages = languages.filter(lang => !selectedLanguages.includes(lang.uuid) || lang.uuid === value)

    return (
      <Select value={value} loading={contentLoading} onChange={(value: any) => this.handleSelectLanguageChange(name, value)} style={{width: 150}}>
        {
          languages?.map(lang => (
            <Select.Option key={lang.uuid} value={lang.uuid}>{lang.name} ({lang.abbreviation})</Select.Option>
          ))
        }
      </Select>
    )
  }

  render() {
    const { form } = this.props

    return (
      <>
        <Typography.Title level={5}>Sponsor Me</Typography.Title>

        <Row>
          <Col xs={24} sm={6} md={6}>
            <Form.Item
              label="Enabled"
              name={['shelter_setting', 'sponsor', 'enabled']}
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>
          </Col>

          <Col xs={24} sm={18} md={18}>
            <Form.Item
              label="Button Text"
              name={['shelter_setting', 'sponsor', 'btnText']}
            >
              <Input addonAfter="Default Language" />
            </Form.Item>

            <Form.List name={[...this.TRANSLATION_FORM_PATH]}>
              {(fields, { add, remove }) => (
                <>
                  {
                    fields.map(field => {
                      const language = form.getFieldValue([...this.TRANSLATION_FORM_PATH, field.name, 'language'])

                      return (
                        <div key={field.key} style={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'flex-end'
                        }}>
                          <Form.Item
                            {...field}
                            name={[field.name, 'value', 'btnText']}
                            rules={[
                              {
                                required: true,
                                message: 'Required field'
                              }
                            ]}
                            style={{
                              width: '100%',
                              marginBottom: 0
                            }}
                          >
                            <Input disabled={!language} addonAfter={this.selectLanguage(field.name)} />
                          </Form.Item>
  
                          <Button type="link" onClick={() => {
                            remove(field.name)

                            if (language) {
                              this.setState((state: any) => ({
                                ...state,
                                selectedLanguages: state.selectedLanguages.filter(p => p !== language)
                              }))
                            }
                          }}>
                            Remove
                          </Button>
                        </div>
                      )
                    })
                  }

                  <Button type="link" onClick={add}>
                    Add translation
                  </Button>
                </>
              )}
            </Form.List>
          </Col>
        </Row>
      </>
    )
  }
}
